import { Routes, Route, Navigate } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollManager from './components/ScrollManager'
import Landing from './pages/Landing'
import BlogIndex from './pages/BlogIndex'
import BlogPost from './pages/BlogPost'
import PluginCommerce from './pages/PluginCommerce'
import PluginCommerceDemo from './pages/PluginCommerceDemo'

export default function App() {
  return (
    <div className="relative min-h-screen">
      <ScrollManager />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/plugin-commerce" element={<PluginCommerce />} />
          <Route path="/plugin-commerce/demo" element={<PluginCommerceDemo />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          {/* Nieznany adres → strona główna, zamiast pustego ekranu. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}
